import { DialogComponent } from '@theme/dialog';
import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';

/**
 * A custom element that manages an inventory store-availability drawer.
 *
 * @typedef {object} Refs
 * @property {HTMLDialogElement} dialog - The dialog element.
 *
 * @extends {DialogComponent}
 */
class InventoryDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    this.#section?.addEventListener(ThemeEvents.variantUpdate, this.#updateInventory);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#section?.removeEventListener(ThemeEvents.variantUpdate, this.#updateInventory);
  }

  open() {
    this.showDialog();
  }

  close() {
    this.closeDialog();
  }

  get #section() {
    return this.closest('.shopify-section, dialog');
  }

  /**
   * Replaces the drawer contents with the newly selected variant's store availability.
   * @type {EventListener}
   */
  #updateInventory = (event) => {
    const { detail } = /** @type {VariantUpdateEvent} */ (event);

    if (detail.data.newProduct) {
      this.dataset.productId = detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newDrawer = /** @type {HTMLElement | null} */ (
      detail.data.html.querySelector(`inventory-drawer-component[data-block-id="${this.dataset.blockId}"]`)
    );

    if (!newDrawer || newDrawer.dataset.variantId === this.dataset.variantId) return;

    this.dataset.variantId = newDrawer.dataset.variantId ?? '';
    this.className = newDrawer.className;
    morph(this, newDrawer, { childrenOnly: true });
  };
}

if (!customElements.get('inventory-drawer-component')) {
  customElements.define('inventory-drawer-component', InventoryDrawerComponent);
}
